export const handleModalClose = (event, action) => {
  if (event.target.className === 'modal-container') {
    action();
  }
  event.stopImmediatePropagation();
};
